module.exports = {"title":"Reset your password","content":"Please enter your new password.","password":"New Password","confirmPassword":"Confirm your new Password","submit":"Submit","passwordsNotTheSame":"The passwords are not the same","useSocial":"Or use your existing account","loginGoogle":"Login with Google","msg":{"yay":"Yay!","oops":"Oops!","success":"Password updated successfully. You can now login."}}


//////////////////
// WEBPACK FOOTER
// ./src/components/ResetPassword/locales/fr.json
// module id = 1767
// module chunks = 0